import { Link, useLocation } from 'react-router-dom';
import { Muted } from '@/components/Typography';
import type { ComponentType } from 'react';

interface NavigationItem {
  name: string;
  href: string;
  icon: ComponentType<{ className?: string }>;
}

interface SidebarSectionProps {
  title: string;
  items: NavigationItem[];
}

export function SidebarSection({ title, items }: SidebarSectionProps) {
  const location = useLocation();

  return (
    <>
      <Muted className="mb-4 text-xs font-semibold uppercase tracking-wider">
        {title}
      </Muted>
      {items.map((item) => {
        const isActive = location.pathname === item.href;
        return (
          <Link
            key={item.name}
            to={item.href}
            className={`group flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-stone-100'
                : 'hover:bg-stone-50 hover:text-stone-900'
            }`}
          >
            <item.icon className="mr-3 h-5 w-5" />
            {item.name}
          </Link>
        );
      })}
    </>
  );
}
